import { authClient, API } from "../../utils/index";

export const getEscapeRooms = (params = {}) => {
	const search = new URLSearchParams({ all: "1" });
	if (params.name) search.set("name", String(params.name).trim());
	if (params.user) search.set("user", String(params.user).trim());
	if (params.limit) search.set("limit", String(params.limit));
	return authClient().get(`${API}/escape-room?${search.toString()}`);
};

/** Misma lista que el portal: solo ER publicados como plantilla global. */
export const getTemplateEscapeRooms = () => {
	return authClient().get(`${API}/escape-room/templates`);
};

/** Escape rooms donde el usuario es colaborador (misma ruta que el portal). */
export const getSharedEscapeRooms = () => {
	return authClient().get(`${API}/escape-room/shared-with-me`);
};

export const getEscapeRoomsByUser = (userId) => {
	return authClient().get(`${API}/escape-room/by-user/${encodeURIComponent(String(userId || ""))}`);
};

export const getEscapeRoomById = (id) => {
	return authClient().get(`${API}/escape-room/${id}`);
};

export const postEscapeRoom = (data) => {
	return authClient().post(`${API}/escape-room`, data);
};

export const updateEscapeRoom = (id, data) => {
	return authClient().put(`${API}/escape-room/${id}`, data);
};

export const deleteEscapeRoom = (id) => {
	return authClient().delete(`${API}/escape-room/${id}`);
};

/** Publicar / despublicar plantilla global y marcar si es premium (solo admin/moderator). */
export const publishEscapeRoomTemplate = (id, options = {}) => {
	const body =
		typeof options === "boolean"
			? { templatePublished: options }
			: {
					...(options.templatePublished !== undefined
						? { templatePublished: Boolean(options.templatePublished) }
						: {}),
					...(options.templatePremium !== undefined
						? { templatePremium: Boolean(options.templatePremium) }
						: {}),
					...(options.templateBasic !== undefined
						? { templateBasic: Boolean(options.templateBasic) }
						: {}),
					...(options.templateCategories !== undefined
						? {
								templateCategories: Array.isArray(options.templateCategories)
									? options.templateCategories.map((x) => String(x)).filter(Boolean)
									: [],
							}
						: options.templateCategory !== undefined
							? {
									templateCategories:
										options.templateCategory === null || options.templateCategory === ""
											? []
											: [String(options.templateCategory)],
								}
							: {}),
				};
	return authClient().post(
		`${API}/escape-room/${encodeURIComponent(String(id || ""))}/publish-template`,
		body
	);
};

/** Catálogo actual de plantillas de botones (incluye escapeRoomId activo). */
export const getButtonTemplateCatalog = () => {
	return authClient().get(`${API}/escape-room/templates/button-catalog`);
};

/** Marcar este ER como fuente del catálogo de plantillas de botones del editor (solo admin/moderator). */
export const setButtonCatalogSource = (id) => {
	return authClient().post(
		`${API}/escape-room/${encodeURIComponent(String(id || ""))}/button-catalog-source`,
		{ enabled: true }
	);
};
